module.exports = "/static/assets/c2533b932cfc2d25008e404315dbe1e2.png";